import every from 'lodash/every'
import * as React from 'react'

const SUBTYPES_WITHOUT_TITLE = ['markdown', 'general']
const TYPES_WITHOUT_HELPER_TEXT = ['summary']
const SUBTYPES_WITHOUT_HELPER_TEXT = ['markdown', 'draw', 'type', 'all']
const TYPES__WITHOUT_REQUIRED_AND_OFFICE_USE = ['summary']
const SUBTYPES_WITHOUT_REQUIRED_AND_OFFICE_USE = ['markdown', 'calculation']
const TYPES_WITHOUT_READ_ONLY = ['summary']
const SUBTYPES_WITHOUT_READ_ONLY = ['markdown', 'calculation']
const TYPES_WITHOUT_REQUIRED_DEMOGRAPHICS = [
  'display_only',
  'file_upload',
  'signature',
  'matrix',
  'table',
  'summary',
  'divider',
]
const TYPES_WITH_ASSIGN_VALUES = ['radio', 'matrix', 'checkbox']
const SUBTYPES_WITH_ASSING_VALUES = [
  'vertical_list',
  'horizontal_list',
  'dropdown',
  'dropdown_multiple',
  'radio',
]

type BuilderQuestionOptions = {
  hasTitle: boolean
  hasHelperText: boolean
  hasRequiredAndOfficeUse: boolean
  hasDemographics: boolean
  hasReadOnly: boolean
  hasAssignValues: boolean
}

function useBuilderQuestionOptions(
  questionSubtype: string,
  questionType: string
): BuilderQuestionOptions {
  const hasTitle = React.useMemo(
    () =>
      every(SUBTYPES_WITHOUT_TITLE, (subtype) => subtype !== questionSubtype),
    [questionSubtype]
  )

  const hasHelperText = React.useMemo(
    () =>
      every(
        SUBTYPES_WITHOUT_HELPER_TEXT,
        (subtype) => subtype !== questionSubtype
      ) && every(TYPES_WITHOUT_HELPER_TEXT, (type) => type !== questionType),
    [questionSubtype, questionType]
  )

  const hasRequiredAndOfficeUse = React.useMemo(
    () =>
      every(
        SUBTYPES_WITHOUT_REQUIRED_AND_OFFICE_USE,
        (subtype) => subtype !== questionSubtype
      ) &&
      every(
        TYPES__WITHOUT_REQUIRED_AND_OFFICE_USE,
        (type) => type !== questionType
      ),
    [questionSubtype, questionType]
  )

  const hasReadOnly = React.useMemo(
    () =>
      every(
        SUBTYPES_WITHOUT_READ_ONLY,
        (subtype) => subtype !== questionSubtype
      ) && every(TYPES_WITHOUT_READ_ONLY, (type) => type !== questionType),
    [questionSubtype, questionType]
  )

  const hasDemographics = React.useMemo(
    () =>
      every(
        TYPES_WITHOUT_REQUIRED_DEMOGRAPHICS,
        (type) => type !== questionType
      ),
    [questionType]
  )

  const hasAssignValues = React.useMemo(() => {
    return (
      TYPES_WITH_ASSIGN_VALUES.includes(questionType) &&
      SUBTYPES_WITH_ASSING_VALUES.includes(questionSubtype)
    )
  }, [questionSubtype, questionType])

  return {
    hasTitle,
    hasHelperText,
    hasRequiredAndOfficeUse,
    hasDemographics,
    hasReadOnly,
    hasAssignValues,
  }
}

export default useBuilderQuestionOptions
